import { css } from "@compiled/react";

import { CustomerStory } from "@/content/customerStories/customerStories.types";
import { Row } from "@/libraries/wpl/foundations/src";

import { CustomerStoriesGridProps } from "../utils";

import { CustomerStoryCard } from ".";

export const CustomerStoriesGrid = ({
    storiesGrid,
    numColumns
}: CustomerStoriesGridProps) => {
    return (
        <>
            {numColumns === 1 ? (
                <Row layout={"12"}>
                    <div css={columnStyles}>
                        {storiesGrid[0] &&
                            storiesGrid[0].stories.map(
                                (story: CustomerStory, index: number) => {
                                    return (
                                        <CustomerStoryCard
                                            key={index}
                                            {...story}
                                        />
                                    );
                                }
                            )}
                    </div>
                </Row>
            ) : numColumns === 2 ? (
                <Row layout={"6-6"}>
                    <div css={columnStyles}>
                        {storiesGrid[0] &&
                            storiesGrid[0].stories.map(
                                (story: CustomerStory, index: number) => {
                                    return (
                                        <CustomerStoryCard
                                            key={index}
                                            {...story}
                                        />
                                    );
                                }
                            )}
                    </div>
                    <div css={columnStyles}>
                        {storiesGrid[1] &&
                            storiesGrid[1].stories.map(
                                (story: CustomerStory, index: number) => {
                                    return (
                                        <CustomerStoryCard
                                            key={index}
                                            {...story}
                                        />
                                    );
                                }
                            )}
                    </div>
                </Row>
            ) : (
                <Row layout={"4-4-4"}>
                    <div css={columnStyles}>
                        {storiesGrid[0] &&
                            storiesGrid[0].stories.map(
                                (story: CustomerStory, index: number) => {
                                    return (
                                        <CustomerStoryCard
                                            key={index}
                                            {...story}
                                        />
                                    );
                                }
                            )}
                    </div>
                    <div css={columnStyles}>
                        {storiesGrid[1] &&
                            storiesGrid[1].stories.map(
                                (story: CustomerStory, index: number) => {
                                    return (
                                        <CustomerStoryCard
                                            key={index}
                                            {...story}
                                        />
                                    );
                                }
                            )}
                    </div>
                    <div css={columnStyles}>
                        {storiesGrid[2] &&
                            storiesGrid[2].stories.map(
                                (story: CustomerStory, index: number) => {
                                    return (
                                        <CustomerStoryCard
                                            key={index}
                                            {...story}
                                        />
                                    );
                                }
                            )}
                    </div>
                </Row>
            )}
        </>
    );
};

const columnStyles = css({
    display: "flex",
    flexDirection: "column",
    gap: "32px"
});
